export default __webpack_public_path__ + "static/nachttaxi-5b38aec5ec9ab11e83dce4c00eb0c308.png";